<template>
  <div class="html">
    <banner :title="title" :content="content"></banner>

    <div class="lcjj">
      <p class="title">
        河南灵创电子科技有限公司简介
      </p>
      <p class="subtitle">
        Company profile
      </p>
      <div class="jj_list">
        <div class="jj_one" v-html="synopsis" />
      </div>
    </div>
    <div class="news_animation">
      <div class="img">
        <img src="@/assets/aboutus/zs.png" alt="" />
      </div>
      <div class="img">
        <img src="@/assets/aboutus/rz.png" alt="" />
      </div>
      <div class="img">
        <img src="@/assets/aboutus/img.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'

export default {
  name: 'Synopsis',
  components: {
    banner
  },
  data() {
    return {
      title: '公司简介',
      content: '快速联系我们及时沟通--了解更多服务',
      lbUrl: [],
      synopsis:
        '河南灵创电子科技有限公司干2011年注册成立，注册资本为1000万元，是一家专注于网络安全运营、网络安全服务、网络安全解决方案的综合服务商。目前，公司的服务网点已覆盖河南省18个地级市，并且在北京建立了分支机构。<br /><br />灵创科技拥有一支具有丰富网络安全攻防实战经验的服务团队，团队内有多位注册信息安全专业人员.获取了CISP、CISP-PTE、CISP-PTS、CISP-DSG、CISSP、CDPSE、CCSK等专业证书。在2019年、2020年、2021年多次参与国家级、省市级攻防演习活动与重保值守累计为上千家政企提供安全解决方案，服务客户涉及政府、金融、医疗、企业等行业及关键信息基础设施单位。<br /><br />灵创科技致力于成为“陪伴您的网络安全守护者”，以网络安全全生命周期运营为理念打造安全服务+体系化流程+智能化平台“三位一体”的综合性运营解决方案，为客户提供全方位、主动性、系统化的安全服务体系，构建可持续安全监测和响应能力，做到“内外兼顾立体防护”实现真正意义上的信息系统安全。',
      // '<div  style="text-indent: 2em;">河南灵创电子科技有限公司于2011年注册成立，注册资本为1000万元，是一家专注于网络安全服务、网络安全解决方案、网络安全产品分销的综合服务商。</div><div style="text-indent: 2em;">公司拥有一支专业的网络安全服务团队，具有丰富的网络安全攻防渗透经验。团队内工程师拥有CISP、CISP-PTE、CISP-PTS、 CISP-DSG、CISSP等证书，在北京建立了分支机构。2019、2020、2021年参与了多次国家级、省市级网络实战攻防演习活动与重保值守。累计为上千家政企提供网络安全产品及安全服务。</div><div style="text-indent: 2em;">灵创科技签约奇安信商业产品河南分销商:  签约火星高科河南核心经销商</div><div>公司经营范围：</div><div style="text-indent: 2em">计算机软件的技术开发、技术咨询、技术转让、技术服务；计算机技术开发、技术咨询、技术转让、技术服务；销售：仪表仪器、办公设备、教学设备、体育器材、消防设备、电子产品。公司拥有包括防火墙/UTM、杀毒软件、入侵检测管理、网络审计、终端管理、加密认证、数据隔离等技术产品。提供各类安全产品解决方案，如：大数据分析、虚拟化、态势感知、云监测等。</div><div>公司团队：</div><div style="text-indent: 2em;">公司有高素质的核心管理层、一流的专业人才和经验丰富的服务队伍，灵活地运用最新的行业及管理知识，采取行之有效的项目管理方法，给我们的客户实施最佳的解决方案。</div><div>公司经营宗旨：</div><div style="text-indent: 2em;">本公司以最专业的技术、最优质的服务为政府、军队、金融、电信、教育、医疗、制造等各行各业，提升信息安全水平，营造安全的信息化环境。成为客户首选的信息安全服务提供商；员工最适宜工作的公司。 </div>',
      zzList: [
        require('../../assets/aboutus/zz1.jpg'),
        require('../../assets/aboutus/zz2.jpg'),
        require('../../assets/aboutus/zz3.jpg'),
        require('../../assets/aboutus/zz4.jpg')
      ]
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="less" scoped>
.html {
  width: 100%;
  min-width: 1200px;

  .lcjj {
    width: 70%;
    margin: 40px auto 50px;
    .title {
      text-align: center;
      font-size: 24px;
      color: rgb(51, 51, 51);
    }
    .subtitle {
      margin-top: 20px;
      text-align: center;
      color: rgb(153, 153, 153);
      font-size: 14px;
      word-break: normal;
      white-space: pre-wrap;
    }
    .jj_list {
      width: 100%;
      margin: 0 auto;
      .jj_one {
        line-height: 30px;
        color: #666666;
        font-size: 14px;
        word-break: normal;
        white-space: pre-wrap;
      }
      .yd {
        line-height: 30px;
        font-weight: bold;

        color: rgb(55, 60, 71);
        font-size: 14px;
        word-break: normal;
        white-space: pre-wrap;
      }
    }
  }
  .news_animation {
    width: 70%;
    margin: 0 auto 50px;
    .title {
      text-align: center;
      font-size: 24px;
      color: rgb(51, 51, 51);
    }
    .subtitle {
      margin-top: 20px;
      text-align: center;
      color: rgb(153, 153, 153);
      font-size: 14px;
      word-break: normal;
      white-space: pre-wrap;
    }
    .img {
      width: 100%;
      margin-top: 50px;
      img {
        width: 100%;
        height: auto;
      }
    }
    .img_list {
      width: 100%;
      margin: 20px auto 30px;
      display: flex;
      flex-wrap: wrap;
      .imgs {
        width: 22%;
        margin-top: 20px;
        margin: 20px 1.5%;

        img {
          width: 100%;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
